import { useSchoolConst } from "../utilities";
import { useEffect } from "preact/hooks";

export default function SiteHeader() {
  const SCHOOL_CONST = useSchoolConst();
  if (typeof window !== "undefined") {
    useEffect(() => {
      const theme_color_meta_tag = document.querySelector(
        'meta[name="theme-color"]'
      );
      if (SCHOOL_CONST.SCHOOL === "generic") {
        theme_color_meta_tag?.remove();
      } else {
        // change header bar colour
        if (theme_color_meta_tag) {
          theme_color_meta_tag.setAttribute("content", SCHOOL_CONST.COLOR);
        } else {
          const new_tag = document.createElement("meta");
          new_tag.setAttribute("name", "theme-color");
          new_tag.setAttribute("content", SCHOOL_CONST.COLOR);
          document.head.appendChild(new_tag);
        }
      }
    }, [SCHOOL_CONST]);
  }
  return (
    <header
      class={`w3-container ${SCHOOL_CONST.SCHOOL}-theme w3-padding-large`}
    >
      <div class="w3-container">
        <h1>Seat Alert</h1>
      </div>
      <nav class="w3-bar w3-white w3-border">
        <a
          class={`w3-bar-item w3-button ${
            SCHOOL_CONST.SCHOOL === "mcmaster" ? "w3-black" : "w3-white"
          }`}
          href="/"
        >
          McMaster
        </a>
        <a
          class={`w3-bar-item w3-button ${
            SCHOOL_CONST.SCHOOL === "mcgill" ? "w3-black" : "w3-white"
          }`}
          href="/mcgill"
        >
          McGill
        </a>
      </nav>
    </header>
  );
}
